import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  timeout: 58000, // 58s — juste sous la limite Cloudflare (60s)
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("jpi_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Les routes IA peuvent prendre jusqu'à 55s — on leur donne plus de temps
  if (config.url?.includes("/ai/")) {
    config.timeout = 58000;
  }
  return config;
});

client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.code === "ECONNABORTED" || err.message?.includes("timeout")) {
      return Promise.reject({ response: { data: { detail: "La génération a pris trop de temps — réessayez." } } });
    }
    return Promise.reject(err);
  }
);

export function apiError(detail) {
  if (detail == null) return "Une erreur est survenue. Reessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default client;